import { render, staticRenderFns } from "./Spbj.vue?vue&type=template&id=0d9759f8&scoped=true&"
import script from "./Spbj.vue?vue&type=script&lang=js&"
export * from "./Spbj.vue?vue&type=script&lang=js&"
import style0 from "./Spbj.vue?vue&type=style&index=0&id=0d9759f8&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d9759f8",
  null
  
)

export default component.exports